import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { InterlayerMapService } from 'app/services/interlayer-map.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { LayerService } from 'app/services/layer.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { MainDataMapService } from 'app/services/main-data-map.service';
import { LRSMap } from 'assets/TS/LRSMap_New';
import VectorLayer from 'ol/layer/Vector';
import { LayerControlItem, SelectOption as LayerSelectOption } from './layer-control-item/layer-control-item.component';
import { CONTAINER_DATA, FloatPopupService } from 'app/services/float-popup.service';
import { FishboneService } from 'app/services/fishbone.service';

export interface LayerControlInputData {
	mapType: 'data' | 'report';
	dataLayerCateCode: string;
	refLayerCateCode?: string;
	refReportLayerCateCode?: string;
}
interface BoundaryLayerItem {
	label: string;
	cateCode: string;
	isBasemap?: boolean;
}

@Component({
  selector: 'app-feat-layer-control',
  templateUrl: './feat-layer-control.component.html',
  styleUrls: ['./feat-layer-control.component.css', './layer-control-item/layer-control-item.component.css']
})
export class FeatLayerControlComponent implements OnInit {

	dataLayer: LayerControlItem; // or first layer in Report case
	refLayer: LayerControlItem; // or second layer in Report case
	reportRefLayer: LayerControlItem;

	fishboneControl: LayerControlItem;

	countyLayer: LayerControlItem;
	bdryLayer: LayerControlItem;

	baseLayer: LayerControlItem;

	// For data map use
	showBdrySelection: boolean;
	private bdryLayers: BoundaryLayerItem[];
	selectedBdry: BoundaryLayerItem;

	private map: LRSMap.Map;
	private mapType: 'data' | 'report';

	constructor(
		// @Inject(MAT_DIALOG_DATA) public data: LayerControlModalData,
		// private dialog: MatDialogRef<FeatLayerControlComponent>,
		@Inject(CONTAINER_DATA) private data: LayerControlInputData,
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private fishboneService: FishboneService,
		private floatPopupService: FloatPopupService,
		private layerService: LayerService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private reportMapService: InterlayerMapService,
		private reportService: InterlayerReportService
	) { }

	close () {
		this.floatPopupService.closePopup(FeatLayerControlComponent);
	}

	onToggleDataLayer(e: LayerControlItem) {
		e.olLayer.setVisible(e.isOn);
		// Set surroundingLayer visibility same as data layer
		if (this.mapType === 'data') {
			const surroundingLayer = this.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
			surroundingLayer.setVisible(e.isOn);
		}
	}
	onToggleRefLayer(e: LayerControlItem) {
		e.olLayer.setVisible(e.isOn);
		this.mapService.bgRefLayerUpdate.next(e.olLayer);
	}
	onToggleReportRefLayer(e: LayerControlItem) {
		// TODO
	}
	onToggleFishbone() {
		this.fishboneService.fishboneControlBS.next({
			isOn: this.fishboneControl.isOn
		});
	}

	onSelectBasemap(e: LayerControlItem) {
		const selected = e.selectOptions.find(o => o.selected);
		if (!selected) {
			return;
		}
		(<any[]>this.map.baseMapLayerGroup.getLayers().getArray()).forEach(l => {
			if (l.getProperties().title === selected.value) {
				l.setVisible(true);
			} else {
				l.setVisible(false);
			}
		});
	}

	onSelectBdry(e: LayerControlItem) {
		const selected = e.selectOptions.find(o => o.selected);
		if (!selected) {
			return;
		}
		this.selectedBdry = this.bdryLayers.find(i => i.cateCode === selected.value);
		const map = this.map;
		const isBasemap = this.selectedBdry.isBasemap;
		const bdryLayerOl = map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName];
		const basemapOl = map.baseMapLayerGroup;
		if (!isBasemap) {
			const info = this.layerService.bdryLayerList.find(l => l.cateCode === this.selectedBdry.cateCode);
			const props = {};
			props[this.attrIndexService.bdryLayerCodeKey] = info.cateCode;
			props[this.attrIndexService.bdryLayerInfoKey] = info.layers;
			bdryLayerOl.setProperties(props);
			bdryLayerOl.setVisible(true);
			basemapOl.setVisible(false);
			this.setBdryTooltipCol(info.cateCode);
		} else {
			bdryLayerOl.setVisible(false);
			basemapOl.setVisible(true);
		}
		this.mapService.bgBdryLayerUpdate.next(bdryLayerOl);
	}
	private setBdryLayers() {
		const map = this.map;
		const selectedLayer = this.activityService.selectedLayerBS.getValue().layer;
		this.bdryLayers = [];
		this.selectedBdry = null;
		this.layerService.bdryLayerList.forEach(l => {
			if (selectedLayer && selectedLayer.category.code === l.cateCode) {
				return;
			}
			if (l.layers.find(layer => layer.state.name === 'CONTENT')) {
				this.bdryLayers.push({
					label: l.label,
					cateCode: l.cateCode
				});
			}
		});
		// Push basemap
		this.bdryLayers.push({
			label: 'Base Map',
			cateCode: null,
			isBasemap: true
		});
		//
		const basemapOl = map.baseMapLayerGroup;
		const bdryLayerOl = map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName];
		if (!basemapOl.getVisible()) {
			this.selectedBdry = this.bdryLayers.find(l => l.cateCode === bdryLayerOl.getProperties()[this.attrIndexService.bdryLayerCodeKey]);
			bdryLayerOl.setVisible(true);
		}
		if (!this.selectedBdry) {
			this.selectedBdry = this.bdryLayers.find(l => l.isBasemap);
			basemapOl.setVisible(true);
			bdryLayerOl.setVisible(false);
		}

		const bdryList = this.bdryLayers.map((i) => {
			return {
				label: i.label,
				selected: this.selectedBdry.cateCode === i.cateCode,
				value: i.cateCode
			}
		})
		this.bdryLayer = {
			isOn: true,
			label: 'Boundary Layer',
			hasToggle: false,
			selectOptions: bdryList,
			opacitySlider: true,
			olLayer: bdryLayerOl
		}
	}
	private setBdryTooltipCol(bdryCateCode: string) {
		switch (bdryCateCode) {
			case this.attrIndexService.cateCodeInc:
				this.attrIndexService.bdryTooltipCol = this.attrIndexService.bdryIncNameCol;
				break;
			case this.attrIndexService.cateCodeUninc:
				this.attrIndexService.bdryTooltipCol = this.attrIndexService.bdryUnincNameCol;
				break;
			default:
				this.attrIndexService.bdryTooltipCol = this.attrIndexService.bdryDisplayNameCol;
				break;
		}
	}

	ngOnInit() {
		this.mapType = this.data.mapType;
		this.map = this.mapType === 'data' ? this.mapService.map : this.reportMapService.map;
		// Data layer
		const dataLayer: VectorLayer<any> = this.mapType === 'data' ?
			 this.map.addedLayers[this.mapLayerService.dataLayerName] : 
			 this.map.addedLayers[this.reportMapService.firstDataLayerName];
		const cateCode = this.data.dataLayerCateCode;
		this.dataLayer = {
			isOn: dataLayer.getVisible(),
			label: this.layerService.getLayerLabelByCateCode(cateCode),
			olLayer: dataLayer,
			hasToggle: true,
		};
		// Reference layer
		const refLayer = this.mapType === 'data' ? 
			this.map.addedLayers[this.mapLayerService.bgReferenceLayerName] :
			this.map.addedLayers[this.reportMapService.secondDataLayerName];
		const refLayerCode = this.mapType === 'data' ? refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] : this.data.refLayerCateCode;
		this.refLayer = {
			isOn: refLayer.getVisible(),
			label: this.layerService.getLayerLabelByCateCode(refLayerCode),
			olLayer: refLayer,
			hasToggle: true,
		};
		// Fishbone
		const fbInfo = this.fishboneService.fishboneControlBS.getValue();
		this.fishboneControl = {
			isOn: fbInfo && fbInfo.isOn ? true : false,
			label: 'Fishbone',
			olLayer: null, // Fishbone may have multiple layers
			hasToggle: true
		}
		// County layer
		if (this.mapType === 'data' && cateCode === this.attrIndexService.cateCodeMatchPoint) {
			const countyLayer = this.map.addedLayers[this.mapLayerService.countyBoundaryLayerName];
			this.countyLayer = {
				isOn: countyLayer.getVisible(),
				label: this.layerService.getLayerLabelByCateCode(this.attrIndexService.cateCodeCounty),
				olLayer: countyLayer,
				hasToggle: true
			};
		} else {
			this.countyLayer = null;
		}
		// Report ref layer
		if (this.mapType === 'report' && this.data.refReportLayerCateCode) {
			const reportRefLayer = this.map.addedLayers[this.reportMapService.backgroundRefLayerName]
			this.reportRefLayer = {
				isOn: reportRefLayer.getVisible(),
				label: this.layerService.getLayerLabelByCateCode(this.data.refReportLayerCateCode),
				olLayer: reportRefLayer,
				hasToggle: true
			};
		} else {
			this.reportRefLayer = null;
		}

		// Base layers
		const basemaps: LayerSelectOption[] = [];
		(<any[]>this.map.baseMapLayerGroup.getLayers().getArray()).forEach(l => {
			basemaps.push({
				label: l.getProperties().title,
				selected: l.getVisible(),
				value: l.getProperties().title
			});
		})
		this.baseLayer = {
			isOn: true,
			label: 'Base Map',
			hasToggle: false,
			selectOptions: basemaps,
			olLayer: this.map.baseMapLayerGroup,
			opacitySlider: true
		}
		
		this.showBdrySelection = this.mapType === 'data';
		this.setBdryLayers();
	}

}
